import { useQuery } from '@tanstack/react-query'
import { LoginApiClient } from '@omnea-app/login/loginHttpClient'
import { throwIfApiError } from '@omnea-app/packages/universal/error-handling/throwifApiError'
import { useToken } from './TokenProvider'

export const useAvailableOrganisations = () => {
  const { getToken } = useToken()
  return useQuery({
    queryKey: ['available-organisations'],
    queryFn: async () => {
      const token = await getToken()
      const loginClient = new LoginApiClient({ authorization: `Bearer ${token}` })
      const { data, error } = await loginClient.GET('/available-organisations')
      throwIfApiError(error)
      return data
    },
  })
}
